module.exports = __webpack_public_path__ + "static/media/Google+.55d8722e.svg";